// barrel file :)
import "./crypto-polyfill";

export * from "./livestream-provider";
// React layer for the livestream store (hooks, context). The pure
// state/factory/reducer is in @streamplace/core and re-exported through
// this local barrel.
export * from "./livestream-store";
export * from "./player-store";
export * from "./streamplace-provider";
export * from "./streamplace-store";
export * from "./video-provider";
export * from "./video-store";

export { AppCrashScreen, ErrorBoundary } from "./components/error-boundary";

export {
  PlayerProvider,
  withPlayerProvider,
} from "./player-store/player-provider";
export { usePlayerContext } from "./player-store/player-store";

export { Player, PlayerUI } from "./components/mobile-player/player";
export { PlayerProps } from "./components/mobile-player/props";

export * as ui from "./components/ui";

export * from "./components/ui";

export * as zero from "./ui";

export * from "./hooks";

// Internationalization system exports
export * from "./i18n";
export * as I18n from "./i18n";

// Theme system exports
export * from "./lib/theme";

export * from "./components/chat/chat";
export * from "./components/chat/chat-box";
export * from "./components/chat/system-message";
export * from "./components/chat/update-stream-title-dialog";
export { default as VideoRetry } from "./components/mobile-player/video-retry";
export * from "./lib/system-messages";

export * from "./components/stream-notification";
export * from "./lib/stream-notifications";

export * from "./utils/did";
export * from "./utils/format-handle";

export { DanmuOverlay } from "./components/danmu/danmu-overlay";
export { DanmuOverlayOBS } from "./components/danmu/danmu-overlay-obs";

// Rotation lock system exports
export {
  RotationProvider,
  useRotation,
} from "./components/mobile-player/rotation-lock";
export type {
  RotationContextValue,
  RotationProviderProps,
} from "./components/mobile-player/rotation-lock";

export * from "./components/share/sharesheet";

export * from "./components/keep-awake";

// Time sync — installs a Date monkeypatch that corrects for server clock
// offset. Must be called once on web before any time-sensitive code runs.
export { initializeTimeSync } from "./time-sync";

// Dashboard components
export * as Dashboard from "./components/dashboard";

// Storage exports
export { default as storage } from "./storage";
export type { AQStorage } from "./storage/storage.shared";

// Content metadata components
export * from "./components/content-metadata";

// Shared metadata constants
export {
  ACTIVITY_LABELS,
  ACTIVITY_LABEL_DISPLAY,
  formatActivity,
} from "./lib/metadata-constants";

// VOD components and interaction hooks
export * from "./components/vod/like-button";
export * from "./components/vod/vod-chat-replay";
export * from "./components/vod/vod-comments";
export * from "./components/vod/vod-mobile-metadata";
export * from "./components/vod/vod-player";
export * from "./components/vod/vod-section";
// React layer for vod-store (React hooks). Pure VOD interaction
// functions are in @streamplace/core and re-exported through this
// local barrel.
export * from "./vod-store";
